// extracted by mini-css-extract-plugin
module.exports = {"linkButton":"style-module--linkButton--SMMwy","button":"style-module--button--7HABh","medium":"style-module--medium--3QmZ_","inlineButton":"style-module--inlineButton--3eHmd"};